package org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/kids/ride_to_read/class_2/wiggly_tooth")
@Composable
fun WigglyToothPage() {
    BlogLayout(
        PageProperties(
            "Wiggly Tooth",
            ""
        ),
        BlogProperties("Ride To Reader", "Stories")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Let Us Read",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sakhi is very ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "excited",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = " for her sixth birthday next week. She can't wait to grow up like her brother, Vedant.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sakhi is ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "daydreaming",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = " about her birthday when she suddenly feels something moving inside her mouth. She rolls her tongue inside her mouth. 'Ooops!' her tooth seemed to be loose. ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "Anxious,",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = " she runs to Mummy's dressing table to look in the mirror. One of her front teeth is a little wiggly.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "\"Mummeeeeeeeeeeee\" she runs crying to her mother. Worried, her mother asks her \"What is the matter? \"Look, my tooth is loose.\" Sakhi opens her mouth wide. \"If it falls off, won't have a tooth to bite with! Can you fix it, please?\"",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Mummy laughs. She says, \"Don't worry, Sakhi, it is a milk tooth. It is meant to fall off.\" \"You mean, I will grow a new one in its place? When?\" asks Sakhi.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "\"Exactly! Soon after it falls off. In fact, you will have more teeth falling. It just means you are growing up.\"",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sakhi is ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "relieved.",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = " But her mind is fixed on the wiggly tooth.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }


                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "And then, Sakhi begins to wiggle ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "wiggle",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = " her loose tooth.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "She wiggles it back and ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "forth.",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "She wiggles it with her fingers. She wiggles it with her tongue.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "She wiggles it at school. She wiggles it at home.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "She wiggles it in the day. She wiggles it at night.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "She wiggles, wiggles, wiggles, wiggles the tooth but it doesn't come out.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It just grows more and more loose.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In the next few weeks, Sakhi grows tired of it, waiting for it to fall. Vedant is also quite ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "fed up. ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = "\"sure wish this tooth falls out now,\" says Vedant at the breakfast table looking at Sakhi wiggling it yet again.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Just then, \"Tuck'- something falls and rolls onto Sakhi's plate. She picks it up and examines it. \"Hey, where did that come from?\"",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Why don't you go and look in the mirror to see where that came from.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = " grins ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = "Vedant. Sakhi walks to the mirror. Mummy, Papa and Vedant follow her. \"Oh! It's my tooth. Finally, it's gone. I am a big girl now.\"",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Papa smiles and says, Yes, my little one, you are growing up fast.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Meaning",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "excited: very happy",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "daydreaming: to be lost in thought",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "wiggly: shaky",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "anxious: worried",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "relieved: to feel happy after a difficult thing has ended or not happened",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "forth: to move forward",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "fed up: irritated",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "grins: a broad smile",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Workbook",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why was Sakhi worried?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Sakhi was worried because her tooth was loose and she if it falls she would not be able to bite.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(topBottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why was Sakhi excited?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Sakhi was excited for her sixth birthday.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(topBottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why was Sakhi worried?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Sakhi was worried because her tooth was loose and she if it falls she would not be able to bite.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(topBottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "When did Sakhi’s tooth fall off?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Sakhi’s tooth fall off at the breakfast table.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(topBottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why was Vedant annoyed with Sakhi?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Vedant was annoyed because sakhi kept wiggling her loose tooth again and again",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(topBottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why did Sakhi grow tired of the wiggling tooth?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Sakhi grew (got) tired because she had been waiting for many days for tooth to fall.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(topBottom = 0.2.em)
                        )
                    }
                }
            }

            SpanText(
                text = "Tick the correct option",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "I would be anxious if ...",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Ol {
                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "I have finished my tiffin.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "I have not completed my homework.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                                .color(Colors.Green)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "I am hungry.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "I have completed my homework.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these are you most likely to get fed up of?",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "a big bar of your favourite chocolate",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "a jun outing with your family",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "too much homework",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                                .color(Colors.Green)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "many friends at your birthday party",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "One would grin when they see something",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Ol {
                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "scary",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "happy",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                                .color(Colors.Green)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "funny",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "sad",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "New Words",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "birthday",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "mouth",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "tongue",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "wiggly",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "examines",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "breakfast",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "fingers",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "tooth",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "mirror",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "loose",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Tick the correct option",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "How old is Sakhi turning on her upcoming birthday? Six",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "In the story, Sakhi is crying about her loose tooth. What reason does she give her mother?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Ol {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The tooth is causing her a lot of pain.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "She thinks she won’t be able to bite anything.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                                    .color(Colors.Green)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "She is scared of going to the dentist.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "She is worried she will look funny.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "What special name does Mummy use for the tooth that is about to fall out?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Ol {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Baby tooth",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Wiggly tooth",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Milk tooth",
                                modifier = Modifier.fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                                    .color(Colors.Green)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Permanent tooth ",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "How does Sakhi first discover that her tooth is loose?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Ol {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "She bites into a hard apple.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "She rolls her tongue inside her mouth.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                                    .color(Colors.Green)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Her brother Vedant notices it first. ",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "She sees it in the mirror while brushing.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            SpanText(
                text = "Answer the following questions in 1-2 sentences each.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Why did Sakhi run crying to her mother?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Sakhi ran crying to her mother because her tooth was loose and she was scared it would fall out.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "How did Sakhi try to make her tooth fall?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Sakhi wiggled her tooth back and forth with her fingers and her tongue.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "How did Sakhi feel when her tooth finally fell?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Sakhi felt happy and proud when her tooth finally fell. She felt like a big girl.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Worksheet - 1",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            SpanText(
                text = "Complete the following.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "Sakhi is very excited for her sixth birthday next week. She can't wait to grow up like her brother, Vedant. Sakhi is daydreaming about her birthday when she suddenly feels something moving inside her mouth. She rolls her tongue inside her mouth. 'Ooops!' her tooth seemed to be loose. Anxious, she runs to Mummy's dressing table to look in the mirror. One of her front teeth is a little wiggly.",
                    modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                )

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "Who does Sakhi want to grow up like?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "Sakhi wants to grow up like her brother Vedant.",
                                modifier = Modifier.fontSize(FontSize.Medium).padding(topBottom = 0.2.em)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "What is Sakhi thinking about?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "Sakhi is thinking about her birthday.",
                                modifier = Modifier.fontSize(FontSize.Medium).padding(topBottom = 0.2.em)
                            )
                        }
                    }
                }

                SpanText(
                    text = "\"Mummeeeeeeeeeeee\" she runs crying to her mother. Worried, her mother asks her \"What is the matter? \"Look, my tooth is loose.\" Sakhi opens her mouth wide. \"If it falls off, I won't have a tooth to bite with! Can you fix it, please?\" Mummy laughs. She says, \"Don't worry, Sakhi, it is a milk tooth. It is meant to fall off.\" \"You mean, I will grow a new one in its place? When?\" asks Sakhi.\n" +
                            "\"Exactly! Soon after it falls off. In fact, you will have more teeth falling. It just means you are growing up.\" Sakhi is relieved. But her mind is fixed on the wiggly tooth.",
                    modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                )

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "Why is Sakhi worried about her tooth?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "Sakhi is worried because she thinks she will not be able to bite if her tooth falls.",
                                modifier = Modifier.fontSize(FontSize.Medium).padding(topBottom = 0.2.em)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "Why does Mummy laugh?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "Mummy laughs because the loose tooth is a milk tooth.",
                                modifier = Modifier.fontSize(FontSize.Medium).padding(topBottom = 0.2.em)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "Why will Sakhi have more teeth falling?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "Sakhi will have more teeth falling because she is growing up.",
                                modifier = Modifier.fontSize(FontSize.Medium).padding(topBottom = 0.2.em)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "How does Sakhi feel after listening to her mother?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "Sakhi feels relieved.",
                                modifier = Modifier.fontSize(FontSize.Medium).padding(topBottom = 0.2.em)
                            )
                        }
                    }
                }
            }

            SpanText(
                text = "Worksheet - 2",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            SpanText(
                text = "Complete the following.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "It just grows more and more loose.\nIn the next few weeks, Sakhi grows tired of it, waiting for it to fall. Vedant is also quite fed up. \"I sure wish this tooth falls out now,\" says Vedant at the breakfast table looking at Sakhi wiggling it yet again.",
                    modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                )

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "What happens to the tooth after all the wiggling?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "The tooth becomes more and more loose.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                                    .padding(topBottom = 0.2.em)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "Why does Sakhi grow tired?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "Sakhi grows tired because she is waiting for the tooth to fall.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                                    .padding(topBottom = 0.2.em)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "How does Vedant feel about Sakhi wiggling her tooth?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "Vedant feels fed up with Sakhi wiggling her tooth.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                                    .padding(topBottom = 0.2.em)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "What does Vedant wish for?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "Vedant wishes that the tooth falls out soon.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                                    .padding(topBottom = 0.2.em)
                            )
                        }
                    }
                }

                SpanText(
                    text = "Sakhi walks to the mirror. Mummy, Papa and Vedant follow her. \"Oh! It's my tooth. Finally, it's gone. I am a big girl now.\" Papa smiles and says, \"Yes, my little one, you are growing up fast.\"",
                    modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                )

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "What does Sakhi realise when she looks in the mirror?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "Sakhi realises that her tooth has fallen out.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                                    .padding(topBottom = 0.2.em)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "How does Sakhi feel after her tooth falls?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "Sakhi feels happy and says she is a big girl.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                                    .padding(topBottom = 0.2.em)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "What does Papa say to Sakhi?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "Papa says that she is growing up fast.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                                    .padding(topBottom = 0.2.em)
                            )
                        }
                    }
                }
            }
        }
    }
}